export default "__VITE_ASSET__BnVatxDS__"